import Vue from 'vue'
import { ValidationObserver, ValidationProvider, localize, extend, setInteractionMode } from 'vee-validate'
import ja from 'vee-validate/dist/locale/ja.json'
import * as rules from 'vee-validate/dist/rules'

setInteractionMode('aggressive')
//  setInteractionMode('eager')

extend('alpha', { ...rules.alpha })
extend('alpha_dash', { ...rules.alpha_dash })
extend('alpha_num', { ...rules.alpha_num })
extend('alpha_spaces', { ...rules.alpha_spaces })
extend('between', { ...rules.between })
extend('confirmed', { ...rules.confirmed })
extend('digits', { ...rules.digits })
extend('dimensions', { ...rules.dimensions })
extend('email', { ...rules.email })
extend('excluded', { ...rules.excluded })
extend('ext', { ...rules.ext })
extend('image', { ...rules.image })
extend('integer', { ...rules.integer })
extend('is', { ...rules.is })
extend('is_not', { ...rules.is_not })
extend('length', { ...rules.length })
extend('max', { ...rules.max })
extend('max_value', { ...rules.max_value })
extend('mimes', { ...rules.mimes })
extend('min', { ...rules.min })
extend('min_value', { ...rules.min_value })
extend('numeric', { ...rules.numeric })
extend('oneOf', { ...rules.oneOf })
extend('regex', { ...rules.regex })
extend('required', { ...rules.required })
extend('required_if', { ...rules.required_if })
extend('size', { ...rules.size })
extend('required_nonezero', {
    message: '{_field_}は必須項目です',
    validate(value) {
        return {
            required: true,
            valid: ['', 0, null, undefined].indexOf(value) === -1
        }
    },
    computesRequired: true
})
extend('date', {
    message: '{_field_}は、YYYY/MM/DD形式で入力してください',
    validate(value) {
        return {
            valid: value.match(/^\d{4}\/\d{2}\/\d{2}$/)
        }
    },
    computesRequired: true
})
/* Date Picker用で、YYYY/M/D, MM/DD, M/D等も許可する(Date Pickerで補正) */
extend('date_picker', {
    message: '{_field_}は、YYYY/MM/DD形式で入力してください',
    validate(value) {
        return {
            valid: value.match(/^\d{1,2}\/\d{1,2}$/) || value.match(/^\d{4}\/\d{1,2}\/\d{1,2}$/)
        }
    }
})

localize('ja', ja)

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

